import BaseComponent from '@/components/base';

export default class AbComponent extends BaseComponent {
  static testStore = 'fobTest';

  render() {
    const localTest = this.getWithExpiry(AbComponent.testStore);
    const urlParams = new URLSearchParams(window.location.search);
    const param = urlParams.get('v');

    let showTest = '';

    if (param) {
      this.setWithExpiry(AbComponent.testStore, param, 24 * 60 * 60 * 1000);
      showTest = param;
    } else {
      showTest = localTest ?? 'a';
    }

    if (showTest === 'a') {
      setTimeout(() => {
        document
          .querySelectorAll('.subscribe-benefits-products')
          ?.forEach((x) => x.style && (x.style.display = 'none'));
      }, 1000);
    }

    this.currentTest = showTest;
    const hidingParam = ['a', 'b'].filter((x) => x !== showTest);

    if (this.force) {
      setTimeout(() => {
        const elems = this.querySelectorAll(`[test="${hidingParam}"]`);
        const looks = this.shadowRoot.querySelectorAll(
          `[test="${hidingParam}"]`
        );

        looks.forEach((el) => el.remove());
        elems.forEach((el) => el.remove());

        // Dispatch custom event to notify child components that processing is complete
        this.dispatchEvent(
          new CustomEvent('ab-component-ready', {
            bubbles: true,
            composed: true,
            detail: { currentTest: this.currentTest }
          })
        );
      }, 50);
    } else {
      // If not forcing, dispatch event immediately
      setTimeout(() => {
        this.dispatchEvent(
          new CustomEvent('ab-component-ready', {
            bubbles: true,
            composed: true,
            detail: { currentTest: this.currentTest }
          })
        );
      }, 0);
    }

    return `
        <style>
            ::slotted([test="${hidingParam}"]) {
            display: none !important;
            }
        </style>
        <slot></slot>
    `;
  }

  setWithExpiry(key, value, ttl) {
    const now = new Date();
    const item = {
      value: value,
      expiry: now.getTime() + ttl
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  getWithExpiry(key) {
    const itemStr = localStorage.getItem(key);

    if (!itemStr) {
      return null; // Return null if item does not exist
    }

    const item = JSON.parse(itemStr);
    const now = new Date();

    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }

    return item.value;
  }

  set defaultTest(value) {
    this.setAttribute('default', value);
  }

  get defaultTest() {
    return this.getAttribute('default') ?? 'a';
  }
}
